import { Layout, Menu } from 'antd';
import ButtonIconOutlineMedium from '../../common/ButtonIconOutline/ButtonIconOutlineMedium';
import { Icon } from '../../icon/icon';
import { useEffect, useState } from 'react';
import { cn } from '../../../utils/string/cn.utils';
import { Divider } from 'antd';
import i18next, { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import ButtonTertiaryLarge from '../../common/ButtonTertiary/ButtonTertiaryLarge';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import ROUTER from '../../../routers/Routers';
import { Link } from 'react-router-dom';
import DropdownComponent from '../../common/DropdownComponent/DropdownComponent';
import {
  reloadAdminOrders,
  resetAdminOrdersData,
} from '../../../store/reducers/admin.room.reducer';
import { Avatar } from 'antd';
import { canAccessCmsPage, isSuperAdmin } from '../../../utils/permissions';

const { Sider } = Layout;
const SiderCMS = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user, accessToken } = useSelector(state => state.auth);

  const [collapsed, setCollapsed] = useState(false);
  const items = [
    {
      key: 'vi',
      show: (
        <div className="flex items-center self-stretch py-[8px] px-[12px] gap-[8px]">
          <span className="flex w-[18px] h-[18px]">
            <Icon.ICGlobal />
          </span>
          <span className="text-label-medium">{t('Vietnamese')}</span>
        </div>
      ),
      label: (
        <div className="flex items-center self-stretch py-[8px] px-[12px] gap-[8px]">
          <img src="/assets/icons/VI.svg" />
          <span className="text-label-medium">{t('Vietnamese')}</span>
        </div>
      ),
      onClick: () => {
        i18next.changeLanguage('vi');
      },
    },
    {
      key: 'en',
      show: (
        <div className="flex items-center self-stretch py-[8px] px-[12px] gap-[8px]">
          <span className="flex w-[18px] h-[18px]">
            <Icon.ICGlobal />
          </span>
          <span className="text-label-medium">{t('English')}</span>
        </div>
      ),
      label: (
        <div className="flex items-center self-stretch py-[8px] px-[12px] gap-[8px]">
          <img src="/assets/icons/US.svg" />
          <span className="text-label-medium">{t('English')}</span>
        </div>
      ),
      onClick: () => {
        i18next.changeLanguage('en');
      },
    },
  ];

  const itemsMenu = [
    {
      key: 0,
      icon: <Icon.ICOverview />,
      label: t('Tổng quan'),
      disabled: true,
    },
    {
      key: ROUTER.CMS + ROUTER.CUSTOMER,
      icon: <Icon.ICAccount />,
      label: t('Accounts'),
    },
    {
      key: ROUTER.CMS + ROUTER.DESIGN_CUSTOMER,
      icon: <Icon.ICAccount />,
      label: t('Customers'),
    },
    {
      key: ROUTER.CMS + ROUTER.ORDER,
      icon: <Icon.ICInventory />,
      label: t('Order'),
    },
    {
      icon: <Icon.ICProduct />,
      label: t('Product'),
      key: null,
      children: [
        {
          key: ROUTER.CMS + ROUTER.PRODUCT_INVENTORY,
          label: t('Bán lẻ có tồn kho'),
          // disabled: true,
        },
        {
          key: ROUTER.CMS + ROUTER.PRODUCT_UNINVENTORY,
          label: t('Bán lẻ không tồn kho'),
          disabled: true,
        },
      ],
    },
    {
      key: 1,
      icon: <Icon.ICChart />,
      label: t('Báo cáo'),
      disabled: true,
    },
    {
      key: 2,
      icon: <Icon.ICChart />,
      label: t('Chiến dịch'),
      disabled: true,
    },
  ]
    // super admin thấy mọi mục; tài khoản khác chỉ thấy trang mình được vào (hiện chỉ Khách hàng, xem canAccessCmsPage)
    .filter(item =>
      isSuperAdmin(user)
        ? true
        : typeof item.key === 'string' && canAccessCmsPage(user, item.key)
    )
    .map((item, index) => ({
      ...item,
      onClick: () => {
        if (item.key) navigate(item.key);
      },
      icon: (
        <span className="w-18 h-18 flex items-center text-black-high">
          {item.icon}
        </span>
      ),
      className: cn(
        '!px-12 !m-0 !w-full  !rounded-[4px] ',
        '[&.ant-menu-item-selected]:!bg-primary-secondary [&.ant-menu-item-selected]:!text-black-high [&.ant-menu-item-selected_.text-body-medium]:!text-body-medium-emphasized',
        '[&.ant-menu-item:not(.ant-menu-item-selected):active]:!bg-primary-secondary',
        '[&.ant-menu-submenu]:!p-0 [&_.ant-menu-submenu-title]:!px-12 [&_.ant-menu-submenu-title]:!m-0 [&_.ant-menu-submenu-title]:!w-full [&.ant-menu-submenu-open.ant-menu-submenu-inline]:!bg-primary-secondaryFill [&.ant-menu-submenu-inline_.ant-menu-inline]:!bg-transparent [&.ant-menu-submenu-inline_.ant-menu-inline]:!px-12 [&_.ant-menu-sub]:!ps-18 [&.ant-menu-submenu-inline_.ant-menu-inline]:!pb-12',
        '[&.ant-menu-submenu-selected_.ant-menu-submenu-title_.text-body-medium]:text-body-medium-emphasized [&.ant-menu-submenu-selected_.ant-menu-submenu-title]:!text-black-high',
        '[&.ant-menu-submenu-selected_.ant-menu-item:not(.ant-menu-item-selected):active]:!bg-primary-secondary [&.ant-menu-submenu_.ant-menu-submenu-title:active]:!bg-primary-secondary',
        '[&.ant-menu-submenu_.ant-menu-submenu-popup.ant-menu-submenu-popup_.ant-menu]:!bg-primary-secondaryFill',
        '[&.ant-menu-submenu_.ant-menu-submenu-popup.ant-menu-submenu-popup_.ant-menu]:!p-12',
        '[&.ant-menu-submenu_.ant-menu-submenu-popup.ant-menu-submenu-popup_.ant-menu]:!ps-0',
        '[&.ant-menu-submenu_.ant-menu-submenu-popup.ant-menu-submenu-popup_.ant-menu-item]:!h-40',
        '[&.ant-menu-submenu-selected]:!bg-primary-secondary'
      ),
      label: <span className="text-body-medium">{item.label}</span>,
      children: item.children?.map((child, childIndex) => ({
        ...child,
        onClick: () => {
          if (child.key) navigate(child.key);
        },
        label: <span className="text-body-medium">{child.label}</span>,
        className: cn(
          '!px-12 !rounded-[4px] !m-0 !w-[calc(100%-12px)] !ms-12 !mt-4 ',
          '[&.ant-menu-item-selected]:!bg-primary-secondary [&.ant-menu-item-selected]:!text-black-high [&.ant-menu-item-selected_.text-body-medium]:!text-body-medium-emphasized',
          '[&.ant-menu-item:not(.ant-menu-item-selected):active]:!bg-primary-secondary'
        ),
      })),
    }));

  return (
    <Sider
      width={204}
      collapsed={collapsed}
      collapsedWidth={66}
      className="bg-fills-white flex items-start transition-all duration-150 ease-linear shadow-custom"
    >
      <div
        className={cn(
          'flex  flex-col flex-shrink-0 items-start self-stretch transition-all duration-100 ease-linear h-[100vh]',
          collapsed ? 'w-[66px]' : 'w-[204px]'
        )}
      >
        <div
          className={cn(
            'flex min-h-[64px] py-[12px] px-[16px] items-center justify-between self-stretch transition-all duration-100 ease-linear',
            collapsed ? 'flex-wrap gap-[8px] w-[66px]' : 'flex-row w-[204px]'
          )}
        >
          {collapsed ? (
            <Link
              href="/"
              className={cn(
                'flex aspect-square transition-all duration-150 ease-linear'
              )}
            >
              <img
                src="/assets/logo/icon_fitta.png"
                alt=""
                className="object-cover h-[32px] w-[32px] "
              />
            </Link>
          ) : (
            <Link
              href="/"
              className={cn(
                'flex w-[72px] items-start gap-[8px] transition-all duration-150 ease-linear'
              )}
            >
              <img
                src="/assets/logo/fitta_logo.svg"
                alt=""
                className="object-cover h-[24px]"
              />
            </Link>
          )}

          <ButtonIconOutlineMedium
            icon={<Icon.ICLeftPanelClose />}
            onClick={() => setCollapsed(!collapsed)}
          />
        </div>
        <div className="flex self-stretch items-center">
          <Divider type="horizontal" className="!p-0 m-0 " />
        </div>
        <div className="flex flex-col justify-between items-start self-stretch grow p-16">
          <div className="flex flex-col items-start gap-[8px] grow self-stretch">
            <Menu
              mode="inline"
              inlineCollapsed={collapsed}
              items={itemsMenu}
              selectedKeys={location.pathname}
              className={cn(
                '!border-none gap-8 flex flex-col',
                '[&.ant-menu-inline-collapsed]:!w-34 [&.ant-menu-inline-collapsed_.ant-menu-item]:!h-34 [&.ant-menu-inline-collapsed_.ant-menu-item]:!px-8 [&.ant-menu-inline-collapsed_.ant-menu-submenu-title]:!h-34 [&.ant-menu-inline-collapsed_.ant-menu-submenu-title]:!px-8 [&.ant-menu-inline-collapsed_.ant-menu-submenu-title]:rounded-[4px]'
                // '[&.ant-menu-inline-collapsed_.ant-menu-submenu]:has-[.ant-menu-item-selected]:!bg-primary-secondary'
              )}
            />
          </div>
          <div className="flex flex-col items-start gap-[4px] self-stretch">
            <DropdownComponent
              className="justify-between self-stretch cursor-pointer text-black/80"
              trigger={['click']}
              menu={{
                items: items,
              }}
            >
              {items.find(item => item.key === i18next.language).show}
            </DropdownComponent>
          </div>
        </div>

        <div className="flex self-stretch items-center px-[16px]">
          <Divider type="horizontal" className="!p-0 m-0 " />
        </div>
        <div
          className={cn(
            'flex p-[16px] items-end justify-start gap-[4px] self-stretch overflow-hidden bg-fills-white'
          )}
        >
          <span className="flex min-w-[40px] max-w-[40px] h-[40px] items-center border-[1px] border-black/10 overflow-hidden rounded-[1000px]">
            <Avatar
              size={40}
              src={user?.avatar}
              alt={user?.fullname}
              icon={<Icon.ICUser />}
              className="object-cover"
            />
          </span>
          <div
            className={cn(
              'flex flex-col justify-center items-start',
              collapsed ? 'opacity-0' : 'opacity-100'
            )}
          >
            <span className="text-label-large truncate text-black/60">
              {user?.fullname}
            </span>
            <span className="text-body-small text-black/30">Admin</span>
          </div>
        </div>
      </div>
    </Sider>
  );
};

export default SiderCMS;
